import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useParams, useHistory } from 'react-router-dom';

import { useFilteredData } from '@ts-core/core/hooks/ui';

import AssignmentAnswersTable from '../../components/AssignmentAnswersTable';
import { useAssignmentAnswers, useAssignmentAnswersActions, useAssignment } from '../../hooks';

const AssignmentAnswersPage = () => {
  const history = useHistory();
  const { courseId, assignmentId } = useParams<{ courseId: string; assignmentId: string }>();
  const { assignment } = useAssignment({ courseId, assignmentId });

  const { answers, loading, onGetXlsxData } = useAssignmentAnswers({
    courseId,
    assignmentId,
  });
  const { onRemoveAssignmentAnswer } = useAssignmentAnswersActions({ courseId, assignmentId });
  const { filteredData, onFilterData } = useFilteredData({ items: answers, fields: ['student.name', 'student.email'] });

  const onSelectAssignmentAnswer = useCallback(
    (answer) => {
      history.push(
        `/${courseId}/students/${answer.student._id}/assignments/${assignmentId}?from=/${courseId}/assignments/${assignmentId}/details/answers`
      );
    },
    [history, courseId, assignmentId]
  );

  return (
    <AssignmentAnswersTable
      assignment={assignment}
      answers={filteredData}
      loading={loading}
      onFilterAnswers={onFilterData}
      onDeleteAnswer={onRemoveAssignmentAnswer}
      onSelectAnswer={onSelectAssignmentAnswer}
      onGetXlsxData={onGetXlsxData}
    />
  );
};

AssignmentAnswersPage.propTypes = {
  assignment: PropTypes.object,
};

AssignmentAnswersPage.defaultProps = {
  assignment: {},
};

export default AssignmentAnswersPage;
